import { render, staticRenderFns } from "./LidDataReport.vue?vue&type=template&id=c36461e8&"
import script from "./LidDataReport.vue?vue&type=script&lang=js&"
export * from "./LidDataReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports